import IWebGLPreloadable from 'mediamonks-webgl/renderer/core/IWebGLPreloadable';
import Renderer from '../../renderer/render/Renderer';
import WebGLPreLoader from 'mediamonks-webgl/renderer/core/WebGLPreLoader';
import TextureFormat from "../../renderer/texture/TextureFormat";
import Texture2D from "../../renderer/texture/Texture2D";
import LoadUtils from "mediamonks-webgl/renderer/core/LoadUtils";

export default class TextureLoader extends Texture2D implements IWebGLPreloadable {
  private url: string;
  private _premultiply: boolean = false;

  public loaded: boolean = false;
  public image!: HTMLImageElement;

  constructor(renderer: Renderer, preloader: WebGLPreLoader, url: string, mipsEnabled: boolean = false,
              filterLinear: boolean = true, wrapClamp: boolean = true, flipY = true, format: string = TextureFormat.RGBA_UNSIGNED_BYTE, premultiply: boolean = false) {

    super(renderer, format, mipsEnabled, filterLinear, wrapClamp);
    this.flipY = flipY;
    this.url = url;
    this.name = url;
    this._premultiply = premultiply;
    preloader.add(this);
  }

  public load(callback: () => void): void {
    LoadUtils.loadImage(this.url, (image) => {
      this.setImage(image, this.flipY, this._premultiply);
      this.loaded = true;
      this.image = image;
      callback.call(this);
    });
  }
}
